import React from 'react';
import { Box, Typography, Button, Grid } from '@mui/material';
import useStyles from "../../../assets/styles/HomeStyles";
import Icon1 from "../../../assets/images/DQProImages/Graphic1.png"
import Icon2 from "../../../assets/images/DQProImages/Graphic2.png"
import Icon3 from "../../../assets/images/DQProImages/Graphic3.png"
import Icon4 from "../../../assets/images/DQProImages/Graphic4.png"

const DQProOnboardingHowToStart = () => {
    const classes = useStyles();

    const steps = [
        {
            number: 1,
            image: Icon1,
            description: "Reach out to your client networks such as a school or community organization with our sales resources.",
            buttonText: "Sales Resources",
            buttonLink: "/dq_pro/sales/resources"
        },
        {
            number: 2,
            image: Icon2,
            description: "Find out what products they want. Please check product availability under ‘Your Product List’ or create your own!",
            buttonText: "View Products",
            buttonLink: "/dq_pro/products"
        },
        {
            number: 3,
            image: Icon3,
            description: "Add them to your client list into this dashboard and assign their product license.",
            buttonText: "Your Client List",
            buttonLink: "/dq_pro/clients/list"
        },
        {
            number: 4,
            image: Icon4,
            description: "For video tutorials and more details of how things work, you can go through our onboarding deck.",
            buttonText: "View Onboarding Deck",
            buttonLink:
                "https://www.canva.com/design/DAGzzwr275g/_iBlM44VBtksRFBqwsflpA/view?utm_content=DAGzzwr275g&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=h3d83547b0e"
        }
    ];

    return (
        <Box className={classes.pageContainer} style={{marginTop:'auto'}}>
            <Typography variant="h3" className={classes.title} sx={{ mb: 4 }}>
                How to Start
            </Typography>

            <Grid container spacing={4}>
                {steps.map((step, index) => (
                    <Grid item xs={12} sm={6} md={3} key={index}>
                        <Box sx={{
                            p: 3,
                            height: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            textAlign: 'center'
                        }}>
                            <Box sx={{
                                color: '#ff6468',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '60px',
                                fontWeight: 'bold',
                                mb: 2
                            }}>
                                {step.number}
                            </Box>
                            <img style={{height:'170px', marginTop:'0px'}} src={step.image} className={classes.cardImage} alt="Card Image" />
                            <Typography sx={{ fontSize:'20px',mb: 3, marginTop:'20px',flexGrow: 1 }}>
                                {step.description}
                            </Typography>

                            {step.buttonText && (
                                <Button
                                    variant="contained"
                                    href={step.buttonLink}
                                    target={index === steps.length - 1 ? "_blank" : undefined}
                                    rel={index === steps.length - 1 ? "noopener noreferrer" : undefined}
                                    sx={{
                                        backgroundColor: '#0097b2',
                                        width: '100%',
                                        fontWeight: 'bold',
                                        fontSize: '16px',
                                        borderRadius: '20px',
                                        '&:hover': {
                                            backgroundColor: '#0097b2',
                                            color:'#ffffff'
                                        }
                                    }}
                                >
                                    {step.buttonText}
                                </Button>
                            )}
                        </Box>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default DQProOnboardingHowToStart;